import React from 'react';

// @ts-ignore
import DOMPurify from 'dompurify';

interface Props {
    element: string;
    html: string;
}

/**
 * ### SafeHTML ###
 * This component safely sets the html of an element to prevent XSS attacks
 * @example <caption>Render html safely in a paragraph element</caption>
 * ```jsx
 *       <SafeHtml element="p" html="<strong>Some text</strong>" />
 * ```
 * @param element The DOM element tha renders the html
 * @param html

 */
export const SafeHtml = ({ element, html }: Props) => {
    return React.createElement(element, {
        dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(html) },
    });
};
